document.addEventListener("DOMContentLoaded", function () {
  let marqueeSlider = document.querySelector('.logo-list .logo-list__wrapper');
  
  if (marqueeSlider) {
    let marqueeSlide = document.querySelector('.logo-list .logo-list__wrapper .logo-list__item .image-element__wrap');
    let mainTicker = new Flickity('.logo-list .logo-list__wrapper', {
      accessibility: true,
      resize: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      percentPosition: true,
      setGallerySize: true,
    });
  
    mainTicker.x = 0;
  
    play();
  
    function play() {
      mainTicker.x -= 1.2;
      mainTicker.settle(mainTicker.x);
      requestId = window.requestAnimationFrame(play);
    }
  
    function pause() {
      if (requestId) {
        window.cancelAnimationFrame(requestId);
        requestId = undefined;
      }
    }
  
    marqueeSlider.addEventListener('mouseenter', () => pause());
    marqueeSlider.addEventListener('mouseleave', () => play());
  }
  
  let productSlider = document.querySelector('.featured-product-slider .product-container');
  if (productSlider) {
    productSlider = new Flickity(productSlider, {
      accessibility: true,
      resize: true,
      wrapAround: true,
      prevNextButtons: true,
      pageDots: true,
      percentPosition: true,
      setGallerySize: true,
    });
  }

  let lazyBgElements = document.querySelectorAll(".lazy-loading");

  let observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        let bgElement = entry.target;
        let bgImage = bgElement.getAttribute("data-bg");
        bgElement.style.backgroundImage = `url(${bgImage})`;
        bgElement.classList.add("loaded");
        observer.unobserve(bgElement);
      }
    });
  });

  lazyBgElements.forEach(element => {
    observer.observe(element);
  });
});

$(document).ready(function() {
  $('.product-description .view-detail').on('click', function() {
    $('html').css('overflow', 'hidden');
    $('.product-popup-preview').addClass('active');
    $('.product-popup-preview .popup-container').flickity({
      accessibility: true,
      resize: true,
      wrapAround: true,
      prevNextButtons: true,
      pageDots: false,
      cellAlign: 'left',
    });
  });

  $('.close-popup, .product-popup-preview').on('click', function(e) {
    if ($(e.target).closest('.popup-container').length === 0 || $(e.target).hasClass('close-popup')) {
      $('.product-popup-preview').removeClass('active');
      $('html').css('overflow', '');

      var $popupContainer = $('.product-popup-preview .popup-container');
      setTimeout(function() {
        if ($popupContainer.data('flickity')) {
          $popupContainer.flickity('destroy');
        }
      }, 1000); 
    }
  });

  $('.popup-container').on('click', function(e) {
    e.stopPropagation();
  });

  $('#recurpay-account-widget').prependTo('.account-sidebar__content');

  $('.tab-title .tab-title-btn.active').each(function() {
      $(this).find('a').removeClass('button--secondary').addClass('button--primary');
  });

  $('.tab-title .tab-title-btn a').on('click', function(e) {
    e.preventDefault(); 
    $('.tab-title .tab-title-btn').removeClass('active').find('a').removeClass('button--primary').addClass('button--secondary');
    $(this).closest('.tab-title-btn').addClass('active');
    $(this).removeClass('button--secondary').addClass('button--primary');
    let handle = $(this).data('handle');
    $('.collection-main .collection__main').removeClass('active');
    $('.collection-main .collection__main').each(function() {
        if ($(this).data('handle') === handle) {
            $(this).addClass('active');
        }
    });
  });

  $('[data-ajax-cart-trigger]').on('click', function() {
    $('.cartUpsellContainer').show();
    let upSellSliderElements = document.querySelectorAll('.cartUpsellContainer .cartUpsellProdBox');
    upSellSliderElements.forEach(function(upSellSliderElement) {
      if (upSellSliderElement && !$(upSellSliderElement).hasClass('flickity-enabled')) {
        let upSellSlider = new Flickity(upSellSliderElement, {
          accessibility: true,
          resize: true,
          wrapAround: true,
          prevNextButtons: true,
          pageDots: false,
          percentPosition: true,
          setGallerySize: true,
        });
      }
    });
  });

  function checkAndAddClass() {
    $(".upsellInnerContainer").each(function () {
      var containerId = $(this).attr("id");
      var matchingProduct = false;
      $(".ajax-cart__list .ajax-cart__product").each(function () {
        var prodId = $(this).data("prod-id");
        if (containerId == prodId) {
          matchingProduct = true;
          return false;
        }
      });
      if (matchingProduct) {
        $(this).addClass("FadedProd");
      } else {
        $(this).removeClass("FadedProd");
      }
    });
  }
  checkAndAddClass();
  setInterval(checkAndAddClass, 3000);

  $('.floating-btn .cross-floating-btn').on('click',function() {
    $('.floating-btn').hide();
  });
  
  $('.menu--hamburger .top a').html(function(_, html) {
    return html.replace('Off', 'Off<br>');
  });

  function moveButton() {
    if ($(window).width() <= 480) {
      $('.purchase-details__buttons .button--add-to-cart').insertAfter('.purchase-details__quantity');
      $('.purchase-details .button--add-to-cart').show();
    }
  } 
  
  function relatedArticle() {
    if ($(window).width() <= 1024) {
      $('.related-articles .related-article-container').flickity({
        freeScroll: true,
        imagesLoaded: true,
        cellAlign: 'left',
        wrapAround: true,
        pageDots: true,
        contain: true,
        prevNextButtons: true,
      });
      $('.blog-posts .home-blog-posts .container:nth-child(2)').flickity({
        freeScroll: false,
        imagesLoaded: true,
        cellAlign: 'left',
        wrapAround: true,
        pageDots: true,
        contain: true,
        prevNextButtons: true,
      });
    }
  }
  
  moveButton();
  relatedArticle();
  
  $(window).resize(function() {
    moveButton();
    relatedArticle();
  });

  $('.product-custom-variant h2').on('click', function() {
    var $currentMainContainer = $(this).parent().find('.main-container'); 

    $('.product-custom-variant .main-container').not($currentMainContainer).slideUp('5000');

    $('.product-custom-variant h2').not($(this)).removeClass('active');

    $(this).toggleClass('active');
    $currentMainContainer.slideToggle('5000');
  });

  $('.form-col').each(function() {
    var $formCol = $(this);
    
    $formCol.find('.product-custom-variant ul li').on('click', function() {
      var selectedFlavor = $(this).data('name'); 
      
      var $selectBox = $formCol.find('select');

      $selectBox.find('option').each(function() {
        if ($(this).text().trim() == selectedFlavor.trim()) {
          $(this).prop('selected', true);
          $selectBox.trigger('change'); 
        }
      });

      $formCol.find('.product-custom-variant ul li').removeClass('active');

      $(this).addClass('active');

      var selectedText = $(this).find('p').text();
      $formCol.find('h2').text(selectedText);
    });
  });
  
  if ($('.recurpay-pdp-widget').length) {
    $('.purchase-details__buttons').insertBefore('.recurpay-pdp-widget');
  }

  function scrollToSection(targetId) {
    let headerHeight = $(".header-sticky-wrapper").outerHeight() || 0;
    let announcementBarHeight = $(".announcement-bar__container").outerHeight() || 0;
    let totalOffset = headerHeight + announcementBarHeight;

    let targetElement = $("#" + targetId);

    if (targetElement.length) {
      $("html, body").animate(
        {
          scrollTop: targetElement.offset().top - totalOffset,
        },
        500 
      );
    }
  }

  if (window.location.hash) {
    let targetId = window.location.hash.substring(1); 
    $("html, body").scrollTop(0); 
    scrollToSection(targetId); 
  }

  $("a[href*='#']").on("click", function () {
    let href = $(this).attr("href");
    if (href.includes("#")) {
      let targetId = href.split("#")[1]; 

      if ($("#" + targetId).length) {
        scrollToSection(targetId); 

        history.pushState(null, null, "#" + targetId);
      }
    }
  });
});

$(window).on('load', function() {
  $('.product-wrap .thumbnail__caption .buttons a').on('click', function() {
    $('html').css('overflow', 'hidden');
    $(this).closest('.product-wrap').find('.product-popup-preview').addClass('active');
  });

  $('.close-popup, .product-popup-preview').on('click', function(e) {
    if ($(e.target).closest('.popup-container').length === 0 || $(e.target).hasClass('close-popup')) {
      $('.product-popup-preview').removeClass('active');
      $('html').css('overflow', '');
    }
  });

  $('.popup-container').on('click', function(e) {
    e.stopPropagation();
  });
});

$(document).on('click', '.menu--hamburger .top a', function(event) {
  event.preventDefault();

  $('.mobile-menu__toggle-button').trigger('click');

  const target = document.getElementById('shopify-section-footer-classic');

  if (target) {
    const offset = 72 + 38; 
    const topPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
        top: topPosition,
        behavior: 'smooth'
    });
  }
});
